import { render } from "./FileInfo.vue?vue&type=template&id=3252c90c&scoped=true"
import script from "./FileInfo.vue?vue&type=script&lang=js"
export * from "./FileInfo.vue?vue&type=script&lang=js"

import "./FileInfo.vue?vue&type=style&index=0&id=3252c90c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3252c90c"],['__file',"src/components/FileInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3252c90c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3252c90c', __exports__)) {
    api.reload('3252c90c', __exports__)
  }
  
  module.hot.accept("./FileInfo.vue?vue&type=template&id=3252c90c&scoped=true", () => {
    api.rerender('3252c90c', render)
  })

}


export default __exports__